// extracted by mini-css-extract-plugin
export var cardTitle = "_iu-1";
export var commentBubble = "_iu-e";
export var commentForm = "_iu-a";
export var commentInput = "_iu-b";
export var commentLabel = "_iu-d";
export var commentPrompt = "_iu-9";
export var csatCard = "_iu-0";
export var feedbackSection = "_iu-7";
export var starDisabled = "_iu-6";
export var starEmpty = "_iu-5";
export var starFilled = "_iu-4";
export var starWrapper = "_iu-3";
export var starsContainer = "_iu-2";
export var submittedComment = "_iu-c";
export var thankYouText = "_iu-8";